import { render, staticRenderFns } from "./ujoy_plus.vue?vue&type=template&id=f0e9a750&scoped=true&"
import script from "./ujoy_plus.vue?vue&type=script&lang=js&"
export * from "./ujoy_plus.vue?vue&type=script&lang=js&"
import style0 from "./ujoy_plus.vue?vue&type=style&index=0&id=f0e9a750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e9a750",
  null
  
)

export default component.exports